module.exports = __webpack_public_path__ + "static/media/Accademia - White -  3955_3377_3364.978fcb50.jpg";